<template>
  <div :class="['selectInput', !isCommon ? 'pop_phone' : '', ispc ? '' : 'mobile_selectInput']">
    <div class="top">
      <select v-model="selectValue" @change="handleSelect" name="" id="">
        <option v-for="item in areaList" :value="item.value" :key="item.value">
          {{ item.label }}
        </option>
      </select>
      <van-icon name="arrow-down" class="down_arr" color="#666" />
      <input
        :class="phoneError ? 'phone_error' : ''"
        v-model="inputvalue"
        @input="phoneChange"
        type="text"
        :placeholder="inputPlaceholder" />
    </div>
    <div class="err_tip" v-show="phoneError">請輸入正確手機號格式</div>
    <div class="check" v-if="isCommon">
      <img :src="checkboxValue ? checkedImg : unCheckedImg" alt="" @click="changCheck" class="check_img" />
    </div>
    <div class="confirm_btn" @click="confirm"></div>
    <div class="time_out" v-if="!isCommon" v-html="countDown(endDate)"></div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'selectInput',
  data() {
    return {
      areaList: [
        {
          label: '香港 +852',
          value: 1,
          lng: 8,
          regx: /^[6|9|5]\d{7}$/,
          placeholder: '6/9/5XXXXXXX'
        },
        {
          label: '台灣+ 886',
          value: 2,
          lng: 9,
          regx: /^[9]\d{8}$/,
          placeholder: '9XXXXXXXX'
        },
        {
          label: '澳門 +853',
          value: 3,
          lng: 8,
          regx: /^[6|8]\d{7}$/,
          placeholder: '6/8XXXXXXX'
        }
      ],
      selectValue: 2,
      maxLng: 9,
      inputvalue: '',
      inputPlaceholder: '9XXXXXXXX',
      checkboxValue: true,
      phoneError: false,
      checkedImg: require('../../assets/xianni/checked.png'),
      unCheckedImg: require('../../assets/xianni/un_checked.png'),
      popCheckedImg: require('../../assets/reservation/pop_checked.png'),
      popUnCheckedImg: require('../../assets/reservation/pop_unchecked.png'),
      endDate: dayjs().add(30, 'second'),
      now: dayjs()
    }
  },
  props: {
    value: {
      type: String | Number,
      default: ''
    },
    isCommon: {
      type: Boolean,
      default: true
    },
    ispc: {
      type: Boolean,
      default: true
    }
  },
  emits: ['confirm'],
  computed: {
    countDown() {
      return function (endDate) {
        let m1 = this.now
        let m2 = dayjs(endDate)
        let du = m2.diff(m1, 'millisecond')
        const second = Math.floor(du / 1000)
        du = du % 1000
        du = Math.floor(du / 10)

        if (second <= 0 && du <= 0) {
          this.endDate = dayjs().add(30, 'second')
          return "<div class='count_down'><span>00</span><span>00</span><span>00</span></div>"
        } else {
          return `<div class='count_down'><span>00</span><span>${second.toString().padStart(2, '0')}</span><span>${du
            .toString()
            .padStart(2, '0')}</span></div>`
        }
      }
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = dayjs()
    }, 10)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    confirm() {
      if (!this.checkboxValue && this.isCommon) {
        this.$message.error('請先勾選：同意個人資料蒐集使用及接收獎勵簡訊')
        return
      }
      const selectValue = this.areaList.find((val) => val.value == this.selectValue)
      console.log(selectValue)
      this.phoneError = false
      if (selectValue.regx.test(this.inputvalue)) {
        this.$emit('confirm', {
          checkboxValue: this.checkboxValue,
          inputvalue: this.inputvalue,
          selectValue
        })
      } else {
        this.phoneError = true
      }
    },
    handleSelect() {
      const item = this.areaList.find((item) => item.value === this.selectValue)
      this.inputPlaceholder = item.placeholder
      this.phoneError = false
    },
    phoneChange() {
      this.phoneError = false
    },
    changCheck() {
      this.checkboxValue = !this.checkboxValue
    },
    backToData() {
      let obj = {
        checkboxValue: this.checkboxValue,
        inputvalue: this.inputvalue,
        selectValue: this.selectValue
      }
      return obj
    },
    resetData() {
      this.inputvalue = ''
      this.checkboxValue = true
    }
  }
}
</script>

<style lang="less" scoped>
.selectInput {
  position: relative;
  .top {
    background: url('../../assets/xianni/phone_input.png') no-repeat 0 0 / 100% auto;
    overflow: hidden;
    width: 21.3vw;
    height: 2.9vw;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .down_arr {
      position: absolute;
      top: 0.94vw;
      left: 6.2vw;
      font-size: 1.2vw;
    }
    select {
      position: relative;
      z-index: 2;
      width: 7.8vw;
      flex-shrink: 0;
      font-size: 1.2vw;
      padding: 0 0.6vw;
      outline: none;
      border: none;
      height: 2.9vw;
      color: #666;
      appearance: none;
      -webkit-appearance: none;
      background: transparent;
      box-sizing: border-box;
    }
    input {
      background: transparent;
      color: #666;
      width: 100%;
      outline: none;
      font-size: 1.2vw;
      height: 2.9vw;
      border: none;
      padding-left: 3.955%;
      &.phone_error {
        color: red;
      }
    }
  }
  .err_tip {
    color: red;
    font-size: 1.2vw;
    position: absolute;
  }

  .check {
    margin-top: 2.24vw;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #4264bb;
    .check_img {
      width: 18.24vw;
      margin-right: 0.64vw;
    }
  }
  .confirm_btn {
    width: 20.4vw;
    height: 4.96vw;
    margin: 1.6vw auto 0;
    background: url('../../assets/xianni/yuyue.gif') no-repeat 0 0 / 20.4vw 4.96vw;
  }
  &.pop_phone {
    position: absolute;
    width: 80%;
    left: 50%;
    transform: translateX(-50%);
    top: 64.2vh;
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
    // background-color: rgba(255, 255, 255, 0.3);
    .confirm_btn {
      // background: none;
      background: url('../../assets/xianni/yuyue.gif') no-repeat 0 0 / 100% auto;
      width: 20vh;
      height: 5vh;
      margin-top: 18vh;
    }
    .err_tip {
      font-size: 1.5vh;
      top: 4.4vh;
      color: #ff8989;
      left: 7.6vh;
    }
    .top {
      background: none;
      width: 36vh;
      height: 4.1vh;
      .down_arr {
        top: 1.3vh;
        left: 17.4vh;
        font-size: 1.7vh;
      }
      select {
        width: 13.4vh;
        font-size: 1.7vh;
        height: 4vh;
        padding: 0 1.8vh;
      }
      option {
        font-size: 1.7vh;
      }
      input {
        width: 100%;
        outline: none;
        height: 4vh;
        font-size: 1.7vh;
        border: none;
        padding-left: 2vh;
      }
    }

    .time_out {
      margin-top: 2.8vh;
      width: 100%;
      height: 2.5vh;
      display: flex;
      padding-left: 22vh;
      ::v-deep .count_down {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #f00;
        gap: 2.8vh;
        span {
          width: 2.4vh;
          font-size: 1.6vh;
          text-align: center;
        }
      }
    }
  }
  &.mobile_selectInput {
    .top {
      background: url('../../assets/xianni/mobile/phone_input.png') no-repeat 0 0 / 100% auto;
      width: 50.5vw;
      height: 6.8vw;
      .down_arr {
        position: absolute;
        top: 2.1vw;
        left: 17.1vw;
        font-size: 2.4vw;
      }
      select {
        width: 18.6vw;
        font-size: 2.4vw;
        height: 6.8vw;
        padding: 0 2.4vw;
      }
      option {
        font-size: 2.4vw;
      }
      input {
        font-size: 2.4vw;
        height: 6.8vw;
        padding-left: 2vw;
        &.phone_error {
          color: red;
        }
      }
    }

    .err_tip {
      font-size: 1.8vw;
      padding-left: 4vw;
    }

    .check {
      margin-top: 4vw;
      .check_img {
        width: 56vw;
      }
    }
    .confirm_btn {
      width: 38.9vw;
      height: 10vw;
      margin: 4vw auto 0;
      background: url('../../assets/xianni/mobile/yuyue.gif') no-repeat 0 0 / 38.9vw 10vw;
    }

    &.pop_phone {
      position: absolute;
      width: 80%;
      left: 50%;
      transform: translateX(-50%);
      top: 64.2vh;
      display: flex;
      justify-content: center;
      flex-flow: row wrap;
      .confirm_btn {
        // background: none;
        background: url('../../assets/xianni/mobile/yuyue.gif') no-repeat 0 0 / 100% auto;
        width: 20vh;
        height: 5vh;
        margin-top: 18vh;
      }
      .err_tip {
        font-size: 1.5vh;
        top: 4.4vh;
        color: #ff8989;
        left: 5.6vh;
      }
      .top {
        background: none;
        width: 36vh;
        height: 4.1vh;
        .down_arr {
          top: 1.3vh;
          left: 17.6vh;
          font-size: 1.5vh;
        }
        select {
          width: 13.4vh;
          font-size: 1.7vh;
          height: 4vh;
          padding: 0 2.2vh;
        }
        option {
          font-size: 2vh;
        }
        input {
          width: 100%;
          outline: none;
          height: 4vh;
          font-size: 1.7vh;
          border: none;
          padding-left: 2vh;
        }
      }
      .time_out {
        margin-top: 2.8vh;
        width: 100%;
        height: 2.5vh;
        display: flex;
        padding-left: 22vh;
        ::v-deep .count_down {
          display: flex;
          justify-content: center;
          align-items: center;
          color: #f00;
          gap: 2.8vh;
          span {
            width: 2.4vh;
            font-size: 1.6vh;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
